function pagination(array, currentPage, postPerPage) {
  const indexOfLastPost = currentPage * postPerPage
  const indexOfFirstPost = indexOfLastPost - postPerPage
  const currentPosts = array.slice(indexOfFirstPost, indexOfLastPost)
  const totalPages = Math.ceil(array.length / postPerPage)
  return { currentPosts, totalPages }
}
export default pagination